import React from 'react';
import { CTAButton } from './CTAButton';
import { LockIcon, ShieldCheckIcon, ZapIcon, HeadphonesIcon, BookOpenIcon } from 'lucide-react';
export function PriceBlock() {
  return <section id="price-block" className="section-dramatic py-24 px-4 border-t border-navy-800" data-id="element-242">
      {/* Dramatic Background */}
      <div className="flag-bg opacity-30 mix-blend-overlay" data-id="element-243"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/70 to-navy-950 z-0 pointer-events-none" data-id="element-244"></div>

      {/* Crowd Silhouette */}
      <div className="crowd-bottom opacity-90" data-id="element-245"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-246">
        <div className="glass-card border-patriot-red/40 bg-navy-950/80 p-8 md:p-14 shadow-[0_0_80px_rgba(178,34,52,0.2)] rounded-3xl relative overflow-hidden backdrop-blur-xl" data-id="element-247">
          {/* Animated border glow */}
          <div className="absolute inset-0 border-2 border-patriot-red/20 rounded-3xl pointer-events-none" data-id="element-248"></div>
          <div className="absolute top-0 left-1/4 right-1/4 h-1 bg-red-gradient shadow-[0_0_30px_rgba(178,34,52,1)]" data-id="element-249"></div>

          <div className="inline-flex items-center gap-2 px-5 py-2 text-sm font-bold tracking-widest text-white bg-red-gradient uppercase rounded-full shadow-lg mb-10" data-id="element-250">
            <ZapIcon className="w-4 h-4" data-id="element-251" />
            EXCLUSIVE OFFER — LIMITED TIME
          </div>

          <h2 className="text-4xl md:text-5xl font-black text-white mb-6 text-shadow-sm" data-id="element-252">
            History is not written by those who stay silent
          </h2>

          {/* eBook Cover */}
          <div className="flex justify-center py-8" data-id="element-253">
            <div className="relative group" data-id="element-254">
              <div className="absolute -inset-8 bg-patriot-red/20 blur-3xl rounded-full pointer-events-none" data-id="element-255"></div>
              <div className="absolute -inset-12 bg-patriot-blue/20 blur-3xl rounded-full pointer-events-none" data-id="element-256"></div>
              <img src="https://cdn.magicpatterns.com/uploads/wUnsaZtGBVT5LLUxt9P4Q7/cover.png" alt="The Voice They Couldn't Silence — eBook Cover" className="relative w-56 md:w-72 h-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.8)] group-hover:scale-105 transition-transform duration-500" data-id="element-257" />
            </div>
          </div>

          <p className="text-xl md:text-2xl text-slate-300 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-258">
            But by those who dare to speak when the cost is highest. Don't just
            buy an eBook;{' '}
            <strong className="text-white border-b-2 border-patriot-red" data-id="element-259">
              acquire an insurance policy for your free will.
            </strong>
          </p>

          {/* What's included */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mb-10" data-id="element-260">
            <div className="flex items-center gap-3 px-6 py-4 rounded-xl bg-navy-900/80 border border-white/10 shadow-lg" data-id="element-261">
              <BookOpenIcon className="w-6 h-6 text-slate-300" data-id="element-262" />
              <span className="text-white font-bold text-lg" data-id="element-263">eBook PDF</span>
            </div>
            <div className="flex items-center gap-2 text-patriot-red font-black text-3xl" data-id="element-264">
              +
            </div>
            <div className="flex items-center gap-3 px-6 py-4 rounded-xl bg-patriot-red/10 border border-patriot-red/40 shadow-[0_0_20px_rgba(178,34,52,0.2)]" data-id="element-265">
              <HeadphonesIcon className="w-6 h-6 text-white" data-id="element-266" />
              <span className="text-white font-bold text-lg" data-id="element-267">
                Audiobook MP3
              </span>
              <span className="text-xs font-black tracking-widest text-patriot-red bg-white px-2 py-1 rounded uppercase shadow-md" data-id="element-268">
                Bonus
              </span>
            </div>
          </div>

          <div className="py-10 border-y border-navy-700/50 mb-10 bg-navy-900/50 rounded-2xl shadow-inner" data-id="element-269">
            <div className="flex flex-col items-center justify-center gap-4" data-id="element-270">
              <div className="flex items-center gap-4" data-id="element-271">
                <span className="text-3xl text-slate-500 line-through font-bold" data-id="element-272">
                  $97.00
                </span>
                <span className="bg-patriot-red text-white px-4 py-1.5 rounded-full text-sm font-black shadow-md" data-id="element-273">
                  SAVE 82%
                </span>
              </div>
              <div className="flex items-start justify-center gap-2" data-id="element-274">
                <span className="text-5xl text-gold-500 font-black mt-2" data-id="element-275">
                  $
                </span>
                <span className="text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gold-gradient tracking-tighter drop-shadow-lg" data-id="element-276">
                  17
                </span>
              </div>
              <p className="text-slate-300 font-mono uppercase tracking-widest mt-4 bg-navy-950/50 px-4 py-2 rounded-lg border border-white/5" data-id="element-277">
                One-Time Payment • Instant Access
              </p>
            </div>
          </div>

          <div className="space-y-8 flex flex-col items-center" data-id="element-278">
            <div className="w-full max-w-xl" data-id="element-279">
              <CTAButton onClick={() => {
              if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_name: "The Voice They Couldn't Silence — eBook + Audiobook",
                  content_type: 'product',
                  value: 17.0,
                  currency: 'USD'
                });
              }
              window.open('https://www.simplementemejor.com/cart/51730114642200:1', '_blank');
            }} className="w-full text-xl md:text-2xl py-6 md:py-8 shadow-[0_0_50px_rgba(178,34,52,0.5)] hover:shadow-[0_0_80px_rgba(178,34,52,0.8)]" data-id="element-280">
                YES, I WANT INSTANT ACCESS FOR JUST $17
              </CTAButton>
            </div>

            <p className="text-patriot-red font-black text-lg animate-pulse bg-patriot-red/10 px-6 py-2 rounded-full border border-patriot-red/20" data-id="element-281">
              Only 147 copies remaining at this price
            </p>

            <div className="flex flex-wrap justify-center gap-6 md:gap-8 text-sm md:text-base text-slate-400 pt-6 border-t border-white/10" data-id="element-282">
              <span className="flex items-center gap-2" data-id="element-283">
                <LockIcon className="w-5 h-5 text-patriot-red" data-id="element-284" />
                256-bit SSL Encryption
              </span>
              <span className="flex items-center gap-2" data-id="element-285">
                <ZapIcon className="w-5 h-5 text-patriot-red" data-id="element-286" />
                Instant Digital Delivery
              </span>
              <span className="flex items-center gap-2" data-id="element-287">
                <ShieldCheckIcon className="w-5 h-5 text-patriot-red" data-id="element-288" />
                30-Day Guarantee
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}